import { hasCrisisPlanFormErrors } from '../components/forms/crisis';

import type { TabbedPageTabDecoration } from '../../../components/layout/tabbedPageShell';
import type {
  ITreatmentPlanV3AssessmentPage,
  ITreatmentPlanV3CrisisPage,
} from '../../../store/treatmentPlanV3';
import type { TreatmentPlanV3TabPageState } from './types';

function toTabDecoration(hasErrors: boolean | null): TabbedPageTabDecoration {
  if (hasErrors == null) return { error: false, success: false };
  return { error: hasErrors, success: !hasErrors };
}

export function getTabPageDecoration<TPage>(
  pageState: TreatmentPlanV3TabPageState<TPage>,
  treatmentPlanId: string | undefined,
  hasErrors: (page: TPage) => boolean,
): TabbedPageTabDecoration {
  if (pageState.treatmentPlanId !== treatmentPlanId) return toTabDecoration(null);
  if (pageState.error != null) return toTabDecoration(true);
  if (pageState.page == null) return toTabDecoration(null);
  return toTabDecoration(hasErrors(pageState.page));
}

export function getCrisisTabDecoration(
  crisis: TreatmentPlanV3TabPageState<ITreatmentPlanV3CrisisPage>,
  assessment: TreatmentPlanV3TabPageState<ITreatmentPlanV3AssessmentPage>,
  treatmentPlanId: string | undefined,
): TabbedPageTabDecoration {
  if (crisis.treatmentPlanId !== treatmentPlanId) return toTabDecoration(null);
  if (crisis.page == null) return toTabDecoration(crisis.error ? true : null);
  if (assessment.page == null || assessment.treatmentPlanId !== treatmentPlanId) {
    return toTabDecoration(null);
  }
  return toTabDecoration(hasCrisisPlanFormErrors(crisis.page, assessment.page.behaviors));
}
